import { Splash, TitleOver } from 'core/styles/Banner'

const PageCover = ({ data, locale }: any) => {
  const title = data?.title
  const layout = data?.layout
  return (
    <div style={{overflow: 'hidden'}}>
      {title && layout === 'title-over' &&
        <TitleOver locale={locale}>
          <div className='container'>
            <h1>{title}</h1>
          </div>
        </TitleOver>
      }
      <Splash background={data.image?.url}
              hasTitle={layout === 'title-over'}
              height={350} />
    </div>
  )
}

export default PageCover